import { cashbookServices } from "@/modules/finances/cashbooks/services/cashbook.services"
import { CashBookDetailDto } from "@/modules/finances/cashbooks/types"
import { ArrowLeftOutlined, PrinterOutlined } from "@ant-design/icons"
import { Button, Card, Flex, Spin, Typography } from "antd"
import dayjs from "dayjs"
import React, { useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"

const { Title } = Typography

const PrintView: React.FC = () => {
  const { id } = useParams<{ id: string }>()
  const navigate = useNavigate()
  const [cashBookData, setCashBookData] = useState<CashBookDetailDto | null>(null)
  const [loading, setLoading] = useState(false)

  const fetchCashBookData = async (cashBookId: string) => {
    setLoading(true)
    try {
      const response = await cashbookServices.getCashBookById(cashBookId)
      if (response?.data) {
        setCashBookData(response.data)
      } else {
        setCashBookData(null)
      }
    } catch (error) {
      console.error('Error fetching cash book data:', error)
      setCashBookData(null)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (id) {
      fetchCashBookData(id)
    }
  }, [id])

  const handleBack = () => {
    navigate('/finances/cashbooks')
  }

  const handlePrint = () => {
    if (!cashBookData) return

    const printWindow = window.open("", "", "width=800,height=600")
    const content = `
      <div style="font-family: Arial, sans-serif; padding: 20px;">
        <div style="display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 20px;">
          <div style="position: relative; margin-bottom: 20px; width: 100%; text-align: center;">
            <div style="text-align: center; width: 100%;">
              <h1 style="margin: 0 0 15px 0; font-size: 18px; font-weight: bold;">SỔ QUỸ TIỀN MẶT</h1>
              <p style="margin: 0 0 8px 0; font-size: 14px;">Năm ${dayjs(cashBookData.from_date).format('YYYY')}</p>
              <p style="margin: 5px 0; font-size: 12px;">Tài khoản: 111</p>
            </div>
            <div style="position: absolute; top: 0; right: 0; text-align: right; min-width: 200px; pointer-events: none;">
              <p style="margin: 5px 0; font-size: 12px;">Mẫu số: S11-H</p>
              <p style="margin: 5px 0; font-size: 10px; color: #666; font-style: italic;">
                (Ban hành theo Thông tư số 107/2017/TT-BTC<br />
                ngày 10/10/2017 của Bộ Tài chính)
              </p>
            </div>
          </div>
        </div>

        <table style="width: 100%; border-collapse: collapse; font-size: 11px; border: 2px solid #000;">
          <thead>
            <tr style="background-color: #f0f0f0; border: 2px solid #000;">
              <th style="border: 1px solid #000; padding: 6px; text-align: center; width: 10%; font-size: 10px;">Ngày, tháng ghi sổ</th>
              <th style="border: 1px solid #000; padding: 6px; text-align: center; width: 10%; font-size: 10px;">Ngày, tháng chứng từ</th>
              <th style="border: 1px solid #000; padding: 6px; text-align: center; width: 12%; font-size: 10px;">Số hiệu chứng từ</th>
              <th style="border: 1px solid #000; padding: 6px; text-align: center; width: 28%; font-size: 10px;">Diễn giải</th>
              <th colspan="3" style="border: 1px solid #000; padding: 6px; text-align: center; font-size: 10px;">Số tiền</th>
              <th style="border: 1px solid #000; padding: 6px; text-align: center; width: 10%; font-size: 10px;">Ghi chú</th>
            </tr>
            <tr style="background-color: #f0f0f0; border: 1px solid #000;">
              <th style="border: 1px solid #000; padding: 4px; text-align: center; font-size: 9px;">A</th>
              <th style="border: 1px solid #000; padding: 4px; text-align: center; font-size: 9px;">B</th>
              <th style="border: 1px solid #000; padding: 4px; text-align: center; font-size: 9px;">C</th>
              <th style="border: 1px solid #000; padding: 4px; text-align: center; font-size: 9px;">D</th>
              <th style="border: 1px solid #000; padding: 4px; text-align: center; width: 10%; font-size: 9px;">Thu</th>
              <th style="border: 1px solid #000; padding: 4px; text-align: center; width: 10%; font-size: 9px;">Chi</th>
              <th style="border: 1px solid #000; padding: 4px; text-align: center; width: 10%; font-size: 9px;">Tồn</th>
              <th style="border: 1px solid #000; padding: 4px; text-align: center; font-size: 9px;">E</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style="border: 1px solid #000; padding: 6px; text-align: center;"></td>
              <td style="border: 1px solid #000; padding: 6px; text-align: center;"></td>
              <td style="border: 1px solid #000; padding: 6px; text-align: center;"></td>
              <td style="border: 1px solid #000; padding: 6px;">Số dư đầu kỳ</td>
              <td style="border: 1px solid #000; padding: 6px; text-align: right;"></td>
              <td style="border: 1px solid #000; padding: 6px; text-align: right;"></td>
              <td style="border: 1px solid #000; padding: 6px; text-align: right; font-weight: bold;">${cashBookData.opening_balance?.toLocaleString() || '0'}</td>
              <td style="border: 1px solid #000; padding: 6px;"></td>
            </tr>
            ${(cashBookData.receipts || []).map((receipt: any, index: number) => `
              <tr>
                <td style="border: 1px solid #000; padding: 6px; text-align: center;">${dayjs(receipt.date_happened || cashBookData.from_date).format('DD/MM/YYYY HH:mm')}</td>
                <td style="border: 1px solid #000; padding: 6px; text-align: center;">${dayjs(receipt.date_happened || cashBookData.from_date).format('DD/MM/YYYY HH:mm')}</td>
                <td style="border: 1px solid #000; padding: 6px; text-align: center;">${receipt.id || ''}</td>
                <td style="border: 1px solid #000; padding: 6px;">${receipt.name || 'Giao dịch'}</td>
                <td style="border: 1px solid #000; padding: 6px; text-align: right;">${receipt.type === 'income' ? (receipt.amount?.toLocaleString() || '0') : ''}</td>
                <td style="border: 1px solid #000; padding: 6px; text-align: right;">${receipt.type === 'expense' ? (receipt.amount?.toLocaleString() || '0') : ''}</td>
                <td style="border: 1px solid #000; padding: 6px; text-align: right; font-weight: bold;">${calculateRunningBalance(cashBookData, index)}</td>
                <td style="border: 1px solid #000; padding: 6px;">${receipt.notes || ''}</td>
              </tr>
            `).join('')}
            <tr style="background-color: #f0f0f0; font-weight: bold; border: 1px solid #000;">
              <td style="border: 1px solid #000; padding: 6px; text-align: center;"></td>
              <td style="border: 1px solid #000; padding: 6px; text-align: center;"></td>
              <td style="border: 1px solid #000; padding: 6px; text-align: center;"></td>
              <td style="border: 1px solid #000; padding: 6px; text-align: left;">Cộng phát sinh kỳ ${dayjs(cashBookData.from_date).format('DD/MM/YYYY HH:mm')} đến ${dayjs(cashBookData.to_date).format('DD/MM/YYYY HH:mm')}</td>
              <td style="border: 1px solid #000; padding: 6px; text-align: right;">${(cashBookData.total_income || 0).toLocaleString()}</td>
              <td style="border: 1px solid #000; padding: 6px; text-align: right;">${(cashBookData.total_expense || 0).toLocaleString()}</td>
              <td style="border: 1px solid #000; padding: 6px; text-align: right;"></td>
              <td style="border: 1px solid #000; padding: 6px;"></td>
            </tr>
            <tr style="background-color: #f0f0f0; font-weight: bold; border: 1px solid #000;">
              <td style="border: 1px solid #000; padding: 6px; text-align: center;"></td>
              <td style="border: 1px solid #000; padding: 6px; text-align: center;"></td>
              <td style="border: 1px solid #000; padding: 6px; text-align: center;"></td>
              <td style="border: 1px solid #000; padding: 6px; text-align: left;">Số dư cuối kỳ ${dayjs(cashBookData.from_date).format('DD/MM/YYYY HH:mm')} đến ${dayjs(cashBookData.to_date).format('DD/MM/YYYY HH:mm')}</td>
              <td style="border: 1px solid #000; padding: 6px; text-align: right;"></td>
              <td style="border: 1px solid #000; padding: 6px; text-align: right;"></td>
              <td style="border: 1px solid #000; padding: 6px; text-align: right;">${(cashBookData.closing_balance || 0).toLocaleString()}</td>
              <td style="border: 1px solid #000; padding: 6px;"></td>
            </tr>
          </tbody>
        </table>

        <div style="margin-top: 60px; display: flex; justify-content: space-between;">
          <div style="text-align: center;">
            <p style="margin: 5px 0; font-weight: bold;">Người lập biểu</p>
            <p style="margin: 5px 0; font-size: 12px;">(Ký, ghi rõ họ tên)</p>
            <div style="height: 60px; border-bottom: 1px solid #000; margin-top: 10px;"></div>
          </div>
          <div style="text-align: center;">
            <p style="margin: 5px 0; font-weight: bold;">Kế toán trưởng</p>
            <p style="margin: 5px 0; font-size: 12px;">(Ký, ghi rõ họ tên)</p>
            <div style="height: 60px; border-bottom: 1px solid #000; margin-top: 10px;"></div>
          </div>
          <div style="text-align: center;">
            <p style="margin: 5px 0; font-weight: bold;">Thủ quỹ</p>
            <p style="margin: 5px 0; font-size: 12px;">(Ký, ghi rõ họ tên)</p>
            <div style="height: 60px; border-bottom: 1px solid #000; margin-top: 10px;"></div>
          </div>
        </div>
      </div>
    `

    printWindow?.document.write(`
      <html>
        <head>
          <style>
            @media print {
              body { margin: 0; }
              table { page-break-inside: avoid; }
            }
          </style>
        </head>
        <body>
          ${content}
        </body>
      </html>
    `)

    printWindow?.document.close()
    printWindow?.focus()
    printWindow?.print()
    printWindow?.close()
  }

  const calculateRunningBalance = (record: CashBookDetailDto, index: number) => {
    let balance = record.opening_balance || 0
    const receipts = record.receipts || []
    
    for (let i = 0; i <= index; i++) {
      const receipt = receipts[i]
      if (receipt.type === 'income') {
        balance += receipt.amount || 0
      } else if (receipt.type === 'expense') {
        balance -= receipt.amount || 0
      }
    }
    
    return balance.toLocaleString()
  }

  if (loading) {
    return (
      <div style={{ padding: '24px', textAlign: 'center' }}>
        <Spin size="large" />
        <p>Đang tải dữ liệu sổ quỹ...</p>
      </div>
    )
  }

  if (!cashBookData) {
    return (
      <div style={{ padding: '24px', textAlign: 'center' }}>
        <p>Không tìm thấy sổ quỹ</p>
        <Button onClick={handleBack}>Quay lại</Button>
      </div>
    )
  }

  return (
    <div style={{ padding: '24px' }}>
      <Card>
        <div style={{ position: 'relative', marginBottom: '20px' }}>
          <Flex align="center" gap={12}>
            <Button 
              type="text" 
              icon={<ArrowLeftOutlined />} 
              onClick={handleBack}
            />
            <Title level={3} style={{ margin: 0 }}>
              In sổ quỹ - {dayjs(cashBookData.from_date).format('DD/MM/YYYY HH:mm')} đến {dayjs(cashBookData.to_date).format('DD/MM/YYYY HH:mm')}
            </Title>
          </Flex>
          <div style={{ position: 'absolute', top: 0, right: 0 }}>
            <Button 
              type="primary" 
              icon={<PrinterOutlined />}
              onClick={handlePrint}
              size="large"
            >
              In sổ quỹ
            </Button>
          </div>
        </div>

        <div style={{ 
          fontFamily: 'Arial, sans-serif', 
          padding: '20px', 
          border: '1px solid #d9d9d9',
          backgroundColor: '#fafafa',
          borderRadius: '6px',
          maxWidth: '1200px',
          margin: '0 auto'
        }}>
          <div style={{ textAlign: 'center', marginBottom: '20px' }}>
            <div style={{ position: 'relative', marginBottom: '20px', width: '100%' }}>
              <div style={{ textAlign: 'center', width: '100%' }}>
                <h1 style={{ fontSize: '18px', fontWeight: 'bold' }}>SỔ QUỸ TIỀN MẶT</h1>
                <p style={{ margin: '0 0 8px 0', fontSize: '14px' }}>Năm {dayjs(cashBookData.from_date).format('YYYY')}</p>
                <p style={{ margin: '5px 0', fontSize: '12px' }}>Tài khoản: 111</p>
              </div>
              <div style={{ position: 'absolute', top: 0, right: 0, textAlign: 'right', minWidth: '200px', pointerEvents: 'none' }}>
                <p style={{ margin: '5px 0', fontSize: '12px' }}>Mẫu số: S11-H</p>
                <p style={{ margin: '5px 0', fontSize: '10px', color: '#666', fontStyle: 'italic' }}>
                  (Ban hành theo Thông tư số 107/2017/TT-BTC<br />
                  ngày 10/10/2017 của Bộ Tài chính)
                </p>
              </div>
            </div>
          </div>

          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '11px', border: '2px solid #000' }}>
            <thead>
              <tr style={{ backgroundColor: '#f0f0f0', border: '2px solid #000' }}>
                <th style={{ border: '1px solid #000', padding: '6px', textAlign: 'center', width: '10%', fontSize: '10px' }}>
                  Ngày, tháng ghi sổ
                </th>
                <th style={{ border: '1px solid #000', padding: '6px', textAlign: 'center', width: '10%', fontSize: '10px' }}>
                  Ngày, tháng chứng từ
                </th>
                <th style={{ border: '1px solid #000', padding: '6px', textAlign: 'center', width: '12%', fontSize: '10px' }}>
                  Số hiệu chứng từ
                </th>
                <th style={{ border: '1px solid #000', padding: '6px', textAlign: 'center', width: '28%', fontSize: '10px' }}>
                  Diễn giải
                </th>
                <th colSpan={3} style={{ border: '1px solid #000', padding: '6px', textAlign: 'center', width: '30%', fontSize: '10px' }}>
                  Số tiền
                </th>
                <th style={{ border: '1px solid #000', padding: '6px', textAlign: 'center', width: '10%', fontSize: '10px' }}>
                  Ghi chú
                </th>
              </tr>
              <tr style={{ backgroundColor: '#f0f0f0', border: '1px solid #000' }}>
                <th style={{ border: '1px solid #000', padding: '4px', textAlign: 'center', fontSize: '9px' }}>A</th>
                <th style={{ border: '1px solid #000', padding: '4px', textAlign: 'center', fontSize: '9px' }}>B</th>
                <th style={{ border: '1px solid #000', padding: '4px', textAlign: 'center', fontSize: '9px' }}>C</th>
                <th style={{ border: '1px solid #000', padding: '4px', textAlign: 'center', fontSize: '9px' }}>D</th>
                <th style={{ border: '1px solid #000', padding: '4px', textAlign: 'center', width: '10%', fontSize: '9px' }}>Thu</th>
                <th style={{ border: '1px solid #000', padding: '4px', textAlign: 'center', width: '10%', fontSize: '9px' }}>Chi</th>
                <th style={{ border: '1px solid #000', padding: '4px', textAlign: 'center', width: '10%', fontSize: '9px' }}>Tồn</th>
                <th style={{ border: '1px solid #000', padding: '4px', textAlign: 'center', fontSize: '9px' }}>E</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ border: '1px solid #000', padding: '6px', textAlign: 'center' }}></td>
                <td style={{ border: '1px solid #000', padding: '6px', textAlign: 'center' }}></td>
                <td style={{ border: '1px solid #000', padding: '6px', textAlign: 'center' }}></td>
                <td style={{ border: '1px solid #000', padding: '6px' }}>
                  <b>Số dư đầu kỳ</b>
                </td>
                <td style={{ border: '1px solid #000', padding: '6px', textAlign: 'right' }}></td>
                <td style={{ border: '1px solid #000', padding: '6px', textAlign: 'right' }}></td>
                <td style={{ border: '1px solid #000', padding: '6px', textAlign: 'right', fontWeight: 'bold' }}>
                  {(cashBookData.opening_balance || 0).toLocaleString()}
                </td>
                <td style={{ border: '1px solid #000', padding: '6px' }}></td>
              </tr>
              {(cashBookData.receipts || []).map((receipt: any, index: number) => (
                <tr key={receipt.id}>
                  <td style={{ border: '1px solid #000', padding: '6px', textAlign: 'center' }}>
                    {dayjs(receipt.date_happened || cashBookData.from_date).format('DD/MM/YYYY HH:mm')}
                  </td>
                  <td style={{ border: '1px solid #000', padding: '6px', textAlign: 'center' }}>
                    {dayjs(receipt.date_happened || cashBookData.from_date).format('DD/MM/YYYY HH:mm')}
                  </td>
                  <td style={{ border: '1px solid #000', padding: '6px', textAlign: 'center' }}>
                    {receipt.id || ''}
                  </td>
                  <td style={{ border: '1px solid #000', padding: '6px' }}>
                    {receipt.name || 'Giao dịch'}
                  </td>
                  <td style={{ border: '1px solid #000', padding: '6px', textAlign: 'right' }}>
                    {receipt.type === 'income' ? (receipt.amount || 0).toLocaleString() : ''}
                  </td>
                  <td style={{ border: '1px solid #000', padding: '6px', textAlign: 'right' }}>
                    {receipt.type === 'expense' ? (receipt.amount || 0).toLocaleString() : ''}
                  </td>
                  <td style={{ border: '1px solid #000', padding: '6px', textAlign: 'right', fontWeight: 'bold' }}>
                    {calculateRunningBalance(cashBookData, index)}
                  </td>
                  <td style={{ border: '1px solid #000', padding: '6px' }}>
                    {receipt.notes || ''}
                  </td>
                </tr>
              ))}
              <tr style={{ backgroundColor: '#f0f0f0', fontWeight: 'bold', border: '1px solid #000' }}>
                <td style={{ border: '1px solid #000', padding: '6px', textAlign: 'center' }}></td>
                <td style={{ border: '1px solid #000', padding: '6px', textAlign: 'center' }}></td>
                <td style={{ border: '1px solid #000', padding: '6px', textAlign: 'center' }}></td>
                <td style={{ border: '1px solid #000', padding: '6px', textAlign: 'left' }}>
                  Cộng phát sinh kỳ {dayjs(cashBookData.from_date).format('DD/MM/YYYY HH:mm')} đến {dayjs(cashBookData.to_date).format('DD/MM/YYYY HH:mm')}
                </td>
                <td style={{ border: '1px solid #000', padding: '6px', textAlign: 'right' }}>
                  {(cashBookData.total_income || 0).toLocaleString()}
                </td>
                <td style={{ border: '1px solid #000', padding: '6px', textAlign: 'right' }}>
                  {(cashBookData.total_expense || 0).toLocaleString()}
                </td>
                <td style={{ border: '1px solid #000', padding: '6px', textAlign: 'right' }}></td>
                <td style={{ border: '1px solid #000', padding: '6px' }}></td>
              </tr>
              <tr style={{ backgroundColor: '#f0f0f0', fontWeight: 'bold', border: '1px solid #000' }}>
                <td style={{ border: '1px solid #000', padding: '6px', textAlign: 'center' }}></td>
                <td style={{ border: '1px solid #000', padding: '6px', textAlign: 'center' }}></td>
                <td style={{ border: '1px solid #000', padding: '6px', textAlign: 'center' }}></td>
                <td style={{ border: '1px solid #000', padding: '6px', textAlign: 'left' }}>
                  Số dư cuối kỳ {dayjs(cashBookData.from_date).format('DD/MM/YYYY HH:mm')} đến {dayjs(cashBookData.to_date).format('DD/MM/YYYY HH:mm')}
                </td>
                <td style={{ border: '1px solid #000', padding: '6px', textAlign: 'right' }}></td>
                <td style={{ border: '1px solid #000', padding: '6px', textAlign: 'right' }}></td>
                <td style={{ border: '1px solid #000', padding: '6px', textAlign: 'right', fontWeight: 'bold' }}>
                  {(cashBookData.closing_balance || 0).toLocaleString()}
                </td>
                <td style={{ border: '1px solid #000', padding: '6px' }}></td>
              </tr>
            </tbody>
          </table>

          <div style={{ marginTop: '60px', display: 'flex', justifyContent: 'space-between', maxWidth: '800px', margin: '60px auto 0' }}>
            <div style={{ textAlign: 'center', flex: 1 }}>
              <p style={{ margin: '5px 0', fontWeight: 'bold' }}>Người lập biểu</p>
              <p style={{ margin: '5px 0', fontSize: '12px' }}>(Ký, ghi rõ họ tên)</p>
              <div style={{ height: '60px', borderBottom: '1px solid #000', marginTop: '10px' }}></div>
            </div>
            <div style={{ textAlign: 'center', flex: 1 }}>
              <p style={{ margin: '5px 0', fontWeight: 'bold' }}>Kế toán trưởng</p>
              <p style={{ margin: '5px 0', fontSize: '12px' }}>(Ký, ghi rõ họ tên)</p>
              <div style={{ height: '60px', borderBottom: '1px solid #000', marginTop: '10px' }}></div>
            </div>
            <div style={{ textAlign: 'center', flex: 1 }}>
              <p style={{ margin: '5px 0', fontWeight: 'bold' }}>Thủ quỹ</p>
              <p style={{ margin: '5px 0', fontSize: '12px' }}>(Ký, ghi rõ họ tên)</p>
              <div style={{ height: '60px', borderBottom: '1px solid #000', marginTop: '10px' }}></div>
            </div>
          </div>
        </div>
      </Card>
    </div>
  )
}

export default PrintView 